import React from "react";
import DateRangePickerSelfComponent from "../../../../../components/date-range-picker/date-range-picker";
import MonthRangepickerComponent from "../../../../../components/month-range-picker/month-rangepicker-apply";
import moment from "moment";
import { countryTypeDictionary } from "@core/global/global-country-dictionary";

const DateRangeContainer = (props) => {
  return (
    <div>
      <div className="daterange_container">
        {props?.latestActualArrivalDate !== "" && props?.userCredit && props?.userCredit?.user_active_plan && props?.fromAccutalArrivalDate && props?.toAccutalArrivalDate && props?.paidPlanDateRange && props.currentPlanAccess ? (
          props.defaultData && props.defaultData?.picker && props.defaultData?.picker?.monthPicker ? (
            <div id="reacttourdaterange">
              <MonthRangepickerComponent
                monthObject={{
                  actualFromYear: props.monthObject.actualFromYear,
                  actualFromMonth: props.monthObject.actualFromMonth,
                  actualToYear: props.monthObject.actualToYear,
                  actualToMonth: props.monthObject.actualToMonth,
                  rangeValue: props.monthObject.rangeValue,
                }}
                monthRangePickerDismiss={(e) => props.monthRangePickerDismiss(e)}
                monthRangePickerChange={(e) => props.monthRangePickerChange(e)}
              />
            </div>
          ) : (
            <div id="reacttourdaterange">
              <DateRangePickerSelfComponent
                initialSettings={{
                  startDate: moment(props.fromAccutalArrivalDate),
                  endDate: moment(props.toAccutalArrivalDate),
                  maxDate: moment(props.latestActualArrivalDate),
                  minDate: moment(props?.defaultData?.countryType.toLowerCase() === countryTypeDictionary.export.toLowerCase() ? props?.userCredit?.export_start_date : props?.userCredit?.import_start_date),
                  ranges: props.paidPlanDateRange,
                  linkedCalendars: false,
                  showDropdowns: true,
                  alwaysShowCalendars: true,
                  applyButtonClasses: "btn btn-primary btn-sm trademo-new-btn",
                  cancelButtonClasses: "btn btn-outline-secondary trademo-outline-btn btn-sm py-2",
                  minYear: moment(props?.defaultData?.countryType.toLowerCase() === countryTypeDictionary.export.toLowerCase() ? props?.userCredit?.export_start_date : props?.userCredit?.import_start_date).format("YYYY"),
                  opens: "right",
                  locale: {
                    format: "MMM D, YYYY",
                    separator: " - ",
                  },
                }}
                userCredit={props.userCredit}
                subscribed_plan={props.currentPlanAccess.subscribed_plan}
                onApply={(e) => props.selectDateRangePicker(e)}
              />
            </div>
          )
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default React.memo(DateRangeContainer);
